import {
  generalTerm,
} from '@/constants/locales/pl.shared.ts';

export default {
  setpoints: {
    header: 'Punkty nastawcze',
  },
  properties: {
    header: 'Właściwości',
    representativeCouponDiameterLabel: generalTerm.representativeDiameter,
    halfInfiniteRadio: 'Pół-nieskończony',
    shapeOrientedRadio: 'Zorientowany na kształt',
  },
  carburizing: {
    header: 'Nawęglanie',
  },
  nitriding: {
    header: 'Azotowanie',
    preNitridedCondition: 'Stan przed azotowaniem',
    estimatedTemperingConditions: 'Szacowane warunki hartowania',
  },
  isnitridingHardnessEffective: {
    true: 'Skuteczny',
    false: 'Rdzeń +',
  },
  materialSimulationData: {
    header: 'Dane symulacji materiałowej',
  },
  savePartAs: {
    header: 'Zapisz część jako',
  },
  newPartDisplayName: 'Nowa część',
  cContent: 'Zawartość C w % wag.',
  nContent: 'Zawartość N w % wag.',
  cnContent: 'Zawartość C/N w % wag.',
  depthCore: 'Głębokość rdzenia w mm',
  depth: 'Głębokość w mm',
  preprocessedProfile: 'Wstępnie przetworzony profil',
  parametrizedProfile: 'Profil sparametryzowany',
  parametrizedProfileDescription: 'Zdefiniuj profil swojej części, określając zawartość powierzchni i rdzenia.',
  surfaceContent: 'Treść powierzchniowa',
  coreContent: 'Treść podstawowa',
  setpointsDescription: 'Rozszerz profil, podając jawne wartości.',
  surfaceHardnessCannotBeAchieved: 'Takiej twardości powierzchni nie da się osiągnąć',
};
